<template>
  <div class="animated fadeIn">
      <h3 align="center">{{fournisseur.nom_commercial}}</h3><br>
    <b-row style="max-width:100%; margin:auto;padding:auto">
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            
            <h4 class="mb-0">{{fournisseur.id_fournisseur_2}}</h4>
            <p>Registre de commerce </p>
          </b-card-body>
          <!-- <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/> -->
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{fournisseur.id_fournisseur_1}}</h4>
            <p>Numero IFU</p>
          </b-card-body>
          <!-- <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/> -->
        </b-card>
      </b-col>
      
       <b-col sm="6" lg="3">
        <b-card no-body class="bg-info" v-if="otherfiles">
          <b-card-body class="pb-0">
            
            <h4 class="mb-0">{{otherfiles.length}}</h4>
            <p>Autres documents</p>
          </b-card-body>
          <!-- <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/> -->
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" >
        <b-card no-body class="bg-primary" v-if="Object.entries(files).length > 0">
          <b-card-body class="pb-0">
             <h4 class="mb-0">{{docCount}}</h4>
            <p>Documents principaux</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

   
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'dashboard',
  components: {
  },
  data: function () {
    return {

    }
  },
  methods: {
   
  },
  computed:{
    ...mapState([
      'fournisseur',
      'files',
      'otherfiles'
    ]),

    docCount(){
      let sum = 0
      for(let elm of Object.entries(this.files)){
            if(Array.isArray(elm[1])) {
              sum = sum + elm[1].length
            }
      }
      return sum;
    },
    
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
